import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { AssigneeSelect } from 'components/common/AssigneeSelect/AssigneeSelect';

import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.types';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Filters.module.scss';

export const Assignee = ({ onFiltersChanged, isLoading }) => {
    const { control } = useFormContext<IFields>();
    return (
        <div className={classes.selectWrapper}>
            <span className={classes.title}>Assignee</span>
            <Controller
                render={({ field }) => (
                    <AssigneeSelect
                        id={'battlecards-filters-assignee'}
                        {...field}
                        onChange={(newValue) => {
                            field.onChange(newValue);
                            onFiltersChanged({ [field.name]: newValue });
                        }}
                        isClearable={true}
                        isLoading={isLoading}
                    />
                )}
                name={`assignee`}
                control={control}
            />
        </div>
    );
};
